// axios
import axios from 'axios'

const axiosIns = axios.create({
    // You can add your headers here
    // ================================
    // baseURL: 'https://127.0.0.1:8000/',
    baseURL: `${import.meta.env.VITE_BASE_URL}/${import.meta.env.VITE_PREFIX}`,
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
})

// eslint-disable-next-line import/no-default-export
export default axiosIns
